import YearsOfExperience from "./experience-components/YearsOfExperience";
import LicenseList from "./experience-components/LicenseList";
import CertificateList from "./experience-components/CertificateList";
import { useProfileItems } from "./experience-components/useProfileItems";
import { fetchLicenses, fetchCertificates } from "../../../../services/experienceService";

const FreelancerExperience = ({ freelancerData }) => {
    const { items: licenses, loading: licensesLoading } = useProfileItems(
        freelancerData?.id,
        fetchLicenses
    );

    const { items: certificates, loading: certsLoading } = useProfileItems(
        freelancerData?.id,
        fetchCertificates
    );

    if (licensesLoading || certsLoading) return null;

    return (
        <div className="info-container experience-section">
            <YearsOfExperience initialYears={freelancerData?.years_of_experience} />
            <LicenseList profileId={freelancerData?.id} initialLicenses={licenses} />
            <CertificateList profileId={freelancerData?.id} initialCertificates={certificates} />
        </div>
    );
};

export default FreelancerExperience;